import { CameraNotificationStatus } from '@EcamModel/model/CameraNotification';
import { Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useNotification } from '../hooks/NotificationProvider';
import LayoutNotificationItem, { NotificationItemProps } from './LayoutNotificationItem';

export default function PcnGrMatchingAlgorithmNotificationItem(props: NotificationItemProps) {
    const navigate = useNavigate();
    const { markRead, handleClose } = useNotification();
    const { item, index } = props;

    const isUnread = item?.Status === CameraNotificationStatus.Unread;

    const handleMarkRead = () => {
        isUnread && markRead([item?.Id!]);
        handleClose();
        navigate(`/verification/contravention/${item?.GroupPotentialContraventionId}?isFilterPcGroupMatched=true`);
    };

    return (
        <LayoutNotificationItem
            handleMarkRead={handleMarkRead}
            index={index}
            item={item}
            children={<Typography>This group was formed by applying the group matching algorithm</Typography>}
            title={`Zone: ${item?.GroupPotentialContravention?.Zone?.PublicName ?? ''}`}
        />
    );
}